import {API, Setup} from '../../Services';

async function FestivalData(){
    let mallId =  localStorage.getItem('mallId');
    const token = localStorage.getItem('token')
    return API.get(`/malls/${mallId?mallId:Setup.default_malls}/campaigns`,{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}


export {FestivalData};
